  import React from "react";
  import classes from "./ArtTherapy.module.css";
  import HeaderLayout from "./headerLayout";
  import EventForm from "./ArtTherapyRegistration";
  import SocialMediaLayout from "./socialHandles";
  import HeaderPart from "./headerPart";
  import styles from './headerLayout.module.css';

  const ArtTherapy = () => {
    return (
      <>
        <div className={classes.bodyContainer}>
          <div className={classes.headerSection}>
            <HeaderPart />
          </div>
          <div className={classes.headerSection}>
            <HeaderLayout />
          </div>
          <div className={classes.formSection}>
            <div className={styles.leftContent}>
              <div className={styles.introSection}>
                <h2> EXPRESSIVE ART WORKSHOP 2.0 – An evening of colors, conversations, and connections.</h2>
                <h3>Why Join This Workshop?</h3>
                <p className={styles.introText}>
                  This workshop isn't just about painting—it's about expressing yourself, 
                  easing your heart, and finding people who truly get you.
                </p>
                <div className={styles.reassurance}>
                  No art skills needed—all materials and refreshments are included.
                </div>

                <div className={styles.benefitsSection}>
                  <h3>What You'll Experience</h3>
                  <div className={styles.benefitsList}>
                    <div className={styles.benefitItem}>
                      <div className={styles.checkmark}>✓</div>
                      <span>A lighter heart & peaceful mind</span>
                    </div>
                    <div className={styles.benefitItem}>
                      <div className={styles.checkmark}>✓</div>
                      <span>Safe space to express yourself</span>
                    </div>
                    <div className={styles.benefitItem}>
                      <div className={styles.checkmark}>✓</div>
                      <span>Meaningful conversations & new friends</span>
                    </div>
                    <div className={styles.benefitItem}>
                      <div className={styles.checkmark}>✓</div>
                      <span>Boost of positivity & liveliness</span>
                    </div>
                  </div>
                </div>
              </div>
            </div> 
            <div className={classes.socialSection}>
              <SocialMediaLayout />
            </div>
          </div>
        </div>
      </>
    );
  };

  export default ArtTherapy;
